// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"991d84de","293":"384073b6","516":"5eb42644","644":"39922478","667":"e0da708e","917":"fec39127","946":"87a80246"}[chunkId] + ".chunk.js";
};